export default {
  nav: {
    firstStep: "LA PREMIÈRE ÉTAPE",
    navigate: "comment naviguer",
    whyUs: "pourquoi veki",
    nice: "quel beau",
    shop: "botique",
    shopAll: "tout",
    shopContainers: "conteneurs",
    shopLarvals: "la larve",
    shopOrganizers: "organisateurs",
    shopBoxes: "BOÎTES",
    shopCategoryKits: "kits",
    shopCategoryLabels: "labels",
    shopCategoryVouchers: "bons",
    organizeDrawer: "organiser tiroir",
    genDimensions: "soumettre dimensions",
    genDesign: "conception",
    materials: "types de finis",
    blog: "inspiration",
    myAccount: "mon compte",
    contact: "contacts"
  },
  user: {
    register: {
      email_blank: "L'email de l'utilisateur ne peut pas être vide.",
      password_blank: "Le mot de passe de l'utilisateur ne peut pas être vide.",
      success: "inscription réussi.",
      user_exists: "L'utilisateur avec ce nom / email existe déjà."
    },
    login: {
      username_blank: "Le nom d'utilisateur ne peut pas être vide.",
      password_blank: "Le mot de passe ne peut pas être vide.",
      invalid_username: "Ce nom d'utilisateur est incorrect.",
      incorrect_password: "Ce mot de passe pour cet utilisateur est incorrect.",
      unexpected_error: "Un problème inattendu a été rencontré.",
      success: "Connecté avec succès."
    },
    unexpected_error: "Un problème inattendu a été rencontré.",
    forgotten_pass: "Mot de passe oublié?"
  },
  contact: {
    contact_subject_blank: "Le sujet du message ne peut pas être vide.",
    contact_name_blank: "Le nom de l'expéditeur ne peut pas être vide.",
    contact_surname_blank:
      "Le nom de famille de l'expéditeur ne peut pas être vide.",
    contact_email_blank:
      "Le courrier électronique de l'expéditeur ne peut pas être vide.",
    contact_message_blank: "Le message ne peut pas être vide.",
    form_success: "Message envoyé avec succès.",
    form_failed:
      "Une erreur s'est produite lors de la tentative d'envoi du message.",
    expired_captcha: "La captcha est expirée."
  },
  cart: {
    update: {
      success: "Mise à jour réussie.",
      errror: "Une erreur s'est produite lors de la mise à jour."
    },
    shipping: {
      not_enough_data:
        "Pas assez de données ont été données pour calculer les coûts d'expédition."
    },
    coupon: {
      apply: {
        cart_empty: "Le panier ne peut pas être vide.",
        code_blank: "Le code du bon d'achat ne peut pas être vide.",
        code_invalid: "Le code de bon fourni est invalide.",
        code_used_up: "Le bon fourni a dépassé la limite d'utilisation.",
        code_expired: "Le bon fourni est expiré.",
        success: "Le bon a été ajouté avec succès.",
        code_exists: "Le bon fourni a déjà été ajouté.",
        error: "Un problème inattendu a été rencontré."
      },
      remove: {
        code_blank: "Le code de bon fourni n’existe pas.",
        success: "Le bon a été supprimé avec succès.",
        code_not_removed: "Le bon n'a pas été supprimé.",
        error: "Un problème inattendu a été rencontré."
      }
    }
  },
  checkout: {
    click_here: "Cliquez ici",
    message: " pour vous connecter / vous inscrire."
  },
  country: {
    PL: 'Pologne',
    KZ: 'Kazakhstan',
    AL: 'Albanie',
    AD: 'Andorre',
    AT: 'Autriche',
    BE: 'Bielgia',
    BY: 'Biélorussie',
    BA: 'Bosnie et Herzégovine',
    BG: 'Bulgarie',
    BG_BG_21: 'Smolyan',
    HR: 'Croatie',
    ME: 'Monténégro',
    CZ: 'République tchèque',
    DK: 'Danemark',
    EE: 'Estonie',
    FI: 'Finlande',
    FR: 'France',
    GR: 'Grèce',
    ES: 'Espagne',
    NL: 'Pays-Bas',
    IE: 'Irlande',
    IS: 'Islande',
    LI: 'liechtenstein',
    LT: 'Lituanie',
    LU: 'Luxembourg',
    MK: 'Macédoine',
    MT: 'Malte',
    MC: 'Monaco',
    DE: 'Allemagne',
    NO: 'Norvège',
    PT: 'Portugal',
    RU: 'Russie',
    RO: 'Roumanie',
    SM: 'Saint-Marin',
    RS: 'Serbie',
    CH: 'Suisse',
    SE: 'Suède',
    SK: 'Slovaquie',
    SI: 'Slovénie',
    TR: 'Turquie',
    VA: 'Vatican',
    GB: 'La Grande-Bretagne',
    HU: 'Hongrie',
    IT: 'Italie',
    LV: 'Lettonie',
    CA_NS: 'Nouvelle Ecosse'
  }
};